import React, { useEffect, useState } from "react";
import { Modal, Spin } from "antd";
import { SelectInput } from "../../../../components/globals";
import { shipment_types_options } from "../../../../helpers/GlobalOptions";
import { useFetch } from "../../../../hooks";
import { updateSettings } from "../../../../redux/Actions/settingsAction";

const DefaultManifestShipmentType = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  return (
    <>
      <button
        className="btn btn-sm float-right text-white mr-3"
        style={{
          backgroundColor: "#007bff",
        }}
        onClick={() => setIsModalOpen(true)}
      >
        Default shipment type
      </button>
      {isModalOpen && (
        <ModalDefaultManifestShipmentType
          onClose={() => setIsModalOpen(false)}
        />
      )}
    </>
  );
};

export default DefaultManifestShipmentType;

const ModalDefaultManifestShipmentType = ({ onClose }) => {
  const { loading, value: initialValue } = useFetch(
    `/api/v1/settings?log_item=manifest_default_shipment_type`
  );
  const [value, setValue] = useState(undefined);
  const [confirmLoading, setConfirmLoading] = useState(false);

  useEffect(() => {
    if (!loading && initialValue?.data?.body) {
      setValue(initialValue.data.body);
    }
  }, [loading]);

  return (
    <Modal
      title="Default shipment type"
      open={true}
      onOk={async () => {
        setConfirmLoading(true);
        await updateSettings("manifest_default_shipment_type", value)
          .then((res) => {
            if (res.success) {
              onClose();
            }
            return true;
          })
          .finally(() => setConfirmLoading(false));
      }}
      onCancel={onClose}
      okButtonProps={!!value ? {} : { style: { display: "none" } }}
      confirmLoading={confirmLoading || loading}
    >
      {loading ? (
        <div className="text-center">
          <Spin />
        </div>
      ) : (
        <SelectInput
          options={shipment_types_options}
          dropdownMatchSelectWidth={false}
          value={value}
          onChange={(val) => setValue(val)}
        />
      )}
    </Modal>
  );
};
